import React from 'react'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export interface Props {
  percent: number
}

export interface IProgressBar {
  genericProps: Props
}

const useStyles = ( percent: number ) => {
  return makeStyles((theme: Theme) =>
  createStyles({
    bar: {
      width: '100%',
      height: '20px',
      borderRadius: '11px',
      backgroundColor: '#D7E6C8',
      left: '4px',
      right: '4px',
      transition: 'all 10s ease-out'
    },
    fill: {
      width: `${percent}%`,
      height: '100%',
      backgroundColor: '#3FA110',
      borderRadius: '11px',
    }
  }),
  );
}


const ProgressBar = ({ genericProps }: IProgressBar) => {

const classes = useStyles( genericProps.percent )();

const bar = classes.bar;
const fill = classes.fill;

  return (
    <div className={ bar }>
      <div className={ fill } />
    </div>
  )
}

export default ProgressBar;